// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectClientListComponent } from './components/select-client-list/select-client-list.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { selectClientReducer, STATE_NAME } from './store/select-client.reducer';
import { SelectClientEffects } from './store/select-client.effects';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { SelectClientComponent } from './components/select-client/select-client.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { ClientNamePipe } from './components/pipes/client-name.pipe';
import { SelectClientSkeletonComponent } from './components/client-list-skeleton/select-client-skeleton.component';
import { FilterUserClientsPipe } from '@coa/app/shared/select-client-list/components/pipes/filter-user-clients.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    StoreModule.forFeature(STATE_NAME, selectClientReducer),
    EffectsModule.forFeature([SelectClientEffects]),
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatIconModule,
    MatRippleModule,
  ],
  declarations: [
    SelectClientListComponent,
    SelectClientComponent,
    ClientNamePipe,
    FilterUserClientsPipe,
    SelectClientSkeletonComponent,
  ],
  exports: [
    SelectClientListComponent,
    SelectClientComponent,
    ClientNamePipe,
    FilterUserClientsPipe,
  ],
})
export class SelectClientListModule {
}
